/* Home: the day at a glance, then one click to anything that needs attention. */
const DEFAULT_DESTINATION = "/";

/** Only follow same-site paths after sign-in; anything else could be an open redirect. */
export function safeNext(next: string | null): string {
  if (next === null || !next.startsWith("/") || next.startsWith("//") || next.includes("\\")) {
    return DEFAULT_DESTINATION;
  }
  if (
    next.startsWith("/sign-in") ||
    next.startsWith("/forgot-password") ||
    next.startsWith("/verify-code") ||
    next.startsWith("/new-password")
  ) {
    return DEFAULT_DESTINATION;
  }
  return next;
}
